import { render, staticRenderFns } from "./slideTree.vue?vue&type=template&id=0128dc55"
import script from "./slideTree.vue?vue&type=script&lang=js"
export * from "./slideTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports